/** @format */

import { createAction, createReducer } from '@reduxjs/toolkit';

const initialState = {
  categorie: { macroCategorie: null, microCategorie: null, tree: [] },
  cacheDownloadFiles: {}
};
export const updateCategorie = createAction('updateCategorie');
export const updateCacheDownloadFiles = createAction('updateCacheDownloadFiles');
export const resetCacheDownloadFiles = createAction('resetCacheDownloadFiles');

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(updateCategorie, (state, action) => {
      // action is inferred correctly here
      state.categorie = { ...state.categorie, ...action.payload };
    })
    .addCase(updateCacheDownloadFiles, (state, action) => {
      state.cacheDownloadFiles = { ...state.cacheDownloadFiles, ...action.payload };
    })
    .addCase(resetCacheDownloadFiles, (state, action) => {
      state.cacheDownloadFiles = {};
    });
});

export default reducer;
